import { observer } from "mobx-react";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import ClientWizard from "../../wizard/ClientWizard";
import { Spin } from "antd";

const EditClientWizardModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  const handleWizardComplete = async (wizardConfig) => {
    console.log("EDIT WIZARD CONFIG", wizardConfig);

    store.setPreLoaderProps({
      loading: true,
      loadingText: "Updating Client Configuration...",
    });

    try {
      await controller.updateClientWithWizard(controller.editClientWizardModal.clientId, wizardConfig);

      // Reset states and reload clients
      controller.setEditClientWizardModal(null, {
        visible: false,
        loading: false,
        clientData: null,
        wizardData: null,
        clientId: null,
      });

      await controller.loadClients();

      store.setPreLoaderProps({
        loading: false,
        loadingText: "",
      });

      store.displayNotification("Client configuration updated successfully!", "success", true);
    } catch (err) {
      store.setPreLoaderProps({
        loading: false,
        loadingText: "",
      });

      store.displayNotification(err.message || "Failed to update client configuration", "error", true);
    }
  };

  const handleWizardCancel = () => {
    controller.setEditClientWizardModal(null, {
      visible: false,
      loading: false,
      clientData: null,
      wizardData: null,
      clientId: null,
    });
  };

  if (!controller.editClientWizardModal.visible) {
    return null;
  }

  if (controller.editClientWizardModal.loading || !controller.editClientWizardModal.clientData || !controller.editClientWizardModal.wizardData) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0,0,0,0.3)",
          zIndex: 1000,
        }}
      >
        <Spin size="large" tip="Loading client configuration..." />
      </div>
    );
  }

  return (
    <ClientWizard
      store={store}
      controller={controller}
      visible={controller.editClientWizardModal.visible}
      clientData={controller.editClientWizardModal.clientData}
      initialWizardData={controller.editClientWizardModal.wizardData}
      mode="edit"
      onComplete={handleWizardComplete}
      onCancel={handleWizardCancel}
    />
  );
});

export default EditClientWizardModal;
